module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ka":{"PatientCase":"სამედიცინო ჩანაწერი","PatientCaseFinished":"გამოქვეყნდა"},"en":{"PatientCase":"Medical Case","PatientCaseFinished":"Published"}}')
  delete Component.options._Ctor
}
